
// Initialize Google Analytics
export const initGA = () => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID && !window.gtag) {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_MEASUREMENT_ID}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${process.env.REACT_APP_GA_MEASUREMENT_ID}');
    `;
    document.head.appendChild(script2);
  }
};

// Initialize Facebook Pixel - commented out until needed
export const initFBPixel = () => {
  // Facebook Pixel code is commented out until you have a Pixel ID
  if (process.env.REACT_APP_FB_PIXEL_ID && !window.fbq) {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${process.env.REACT_APP_FB_PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${process.env.REACT_APP_FB_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }

};

// Track page views
export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
  
  // FB Pixel page view tracking commented out
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
};

// Track events
export const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
  
  // FB Pixel event tracking commented out
  if (window.fbq) {
    window.fbq('track', eventName, params);
  }
};

// NEW: Specific function for lead tracking (vendor registrations)
export const trackLead = (leadType, additionalData = {}) => {
  // Google Analytics
  if (window.gtag) {
    window.gtag('event', 'generate_lead', {
      event_category: 'Lead',
      event_label: leadType,
      ...additionalData
    });
  }
  
  // Facebook Pixel - Lead event is crucial for FB advertising
  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: leadType,
      ...additionalData
    });
  }
};

// NEW: Track demo/contact requests
export const trackDemoRequest = (source = 'unknown') => {
  trackLead('Demo Request', { source });
  
  // Additional FB custom event for demo requests
  if (window.fbq) {
    window.fbq('trackCustom', 'DemoRequest', { source });
  }
};